import { setSentryUser } from '../../components/sentryReport';

//Reducers can be viewed simply as functions that return some data. All these small pieces of data can be used in App wherever required by importing respective Reducers.

const initialState = {
	isLoginSuccess: false,
	isLoginPending: false,
	loginError: null,
	user: null,
	loaded: true
};

export default function (state = initialState, action) {
	if (action.type === 'SET_LOGIN_PENDING') {
		return {
			...state,
			isLoginPending: action.isLoginPending
		};
	}
	if (action.type === 'SET_LOGIN_SUCCESS') {
		return {
			...state,
			isLoginSuccess: action.isLoginSuccess
		};
	}
	if (action.type === 'SET_LOGIN_ERROR') {
		console.log('setting loginError', action.loginError);
		return {
			...state,
			loginError: action.loginError
		};
	}
	if (action.type === 'SET_USER') {
		//console.log('SET_USER', action.user);
		setSentryUser(action.user.userName);
		return {
			...state,
			user: action.user
		};
	}

	/*if (action.type === 'SET_USERINFO') {
		console.log('SET_USERINFO', action.user);
		return {
			...state,
			userInfo: action.info //Beware! JWT has not changed so... stuff will be out of sync
		};
	}*/
	if (action.type === 'SET_JWT') {
		//from pin login
		return {
			...state,
			jwt: action.token,
			userInfo: action.info
		};
	}
	if (action.type == 'CLEAR_USER') {
		return {
			...state,
			user: null,
			jwt: null,
			userInfo: null
		};
	}
	return state;
}

/*
In case an Action is dispatched from any point in the App, the action will be sent to all Reducers that we have created.

var gitRepos= [];
export default function(state=gitRepos, action){
  switch (action.type) {
    case "Get_Repos": { gitRepos = action.payload;
      console.log(action, 'action');
      return gitRepos;
    }
    break;
  }
  return gitRepos;
}*/
